import { defineStore } from 'pinia';

interface LoadingStoreState {
    activeCount: number;
    visible: boolean;
}

type LoadingActionPayload = {
    visibleFlag?: boolean;
};

const useLoadingStoreState = defineStore('gh-loading-store', {
    state: (): LoadingStoreState => ({
        activeCount: 0,
        visible: false,
    }),
    getters: {
        isLoading: (state): boolean => state.activeCount > 0,
        showLoading: (state): boolean => state.visible,
    },
    actions: {
        start({ visibleFlag = false }: LoadingActionPayload = {}) {
            this.activeCount += 1;
            if (visibleFlag) {
                this.visible = true;
            }
        },
        end({ visibleFlag = false }: LoadingActionPayload = {}) {
            if (this.activeCount > 0) {
                this.activeCount -= 1;
            }

            if (this.activeCount === 0 && visibleFlag) {
                setTimeout(() => {
                    this.visible = false;
                }, 500);
            }
        },
        reset() {
            this.activeCount = 0;
            this.visible = false;
        },
    },
});

type LoadingStorePiniaState = ReturnType<typeof useLoadingStoreState>;

/**
 * 取得 Pinia loading store
 */
export const useAppLoadingStore = (): LoadingStorePiniaState => {
    return useLoadingStoreState();
};
